<template>
  <svg
    class="sm__svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82981 6.91924C7.29318 5.11066 9.38956 4 12 4C14.6104 4 16.7068 5.11065 18.1702 6.91922C19.5389 8.61085 20.3258 10.8722 20.5493 13.3397C20.7378 13.5259 20.9717 13.7803 21.1949 14.0872C21.5727 14.6067 22 15.3859 22 16.3077C22 16.8487 21.8495 17.4205 21.4182 17.9326C21.0076 18.4202 20.4087 18.7744 19.6583 19.0392C18.3137 19.5136 16.2117 19.7922 13 19.8391V19.8462H12C8.21742 19.8462 5.82109 19.5612 4.3417 19.0392C3.59131 18.7745 2.99243 18.4203 2.58178 17.9327C2.15046 17.4206 2 16.8488 2 16.3077C2 15.386 2.42728 14.6068 2.80509 14.0873C3.02831 13.7803 3.26216 13.5259 3.4507 13.3397C3.67416 10.8723 4.46105 8.61089 5.82981 6.91924ZM11.91 17.8462H12C15.7523 17.8462 17.856 17.5542 18.9929 17.1531C19.5506 16.9563 19.7889 16.7625 19.8885 16.6443C19.9673 16.5507 20 16.459 20 16.3077C20 15.995 19.845 15.6315 19.5774 15.2635C19.32 14.9096 19.0316 14.6522 18.9374 14.5726L18.6126 14.2981L18.585 13.8738C18.4333 11.5481 17.7347 9.56063 16.6154 8.17725C15.5163 6.81886 13.9826 6 12 6C10.0174 6 8.48372 6.81887 7.3846 8.17726C6.26526 9.56065 5.56666 11.5481 5.41502 13.8739L5.38736 14.2982L5.06259 14.5726C4.96842 14.6522 4.67997 14.9097 4.42258 15.2636C4.15498 15.6316 4 15.9951 4 16.3077C4 16.459 4.03268 16.5507 4.11154 16.6443C4.21106 16.7625 4.44939 16.9564 5.00714 17.1532C6.13491 17.5511 8.214 17.8415 11.91 17.8462Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 13.5C9 12.9477 9.44772 12.5 10 12.5H14C14.5523 12.5 15 12.9477 15 13.5C15 14.0523 14.5523 14.5 14 14.5H10C9.44772 14.5 9 14.0523 9 13.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 13.5C16 12.9477 16.4477 12.5 17 12.5H19C19.5523 12.5 20 12.9477 20 13.5C20 14.0523 19.5523 14.5 19 14.5H17C16.4477 14.5 16 14.0523 16 13.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 13.5C4 12.9477 4.44772 12.5 5 12.5H7C7.55228 12.5 8 12.9477 8 13.5C8 14.0523 7.55228 14.5 7 14.5H5C4.44772 14.5 4 14.0523 4 13.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 10.5C12.5523 10.5 13 10.9477 13 11.5V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V11.5C11 10.9477 11.4477 10.5 12 10.5Z"
    />
  </svg>
</template>
<style scoped>
.sm__svg {
  fill:currentColor;
}
</style>
